<script>
    import Skill from './Skill.svelte'
</script>

<div>
    <h2 class="text-3xl font-semibold text-center mb-12">Mine kompetencer</h2>
    <div class="flex flex-col space-y-12">
        <div
            class="
            flex flex-col
            lg:flex-row
            items-center
            lg:space-x-12
            space-y-12
            lg:space-y-0
            "
        >
            <Skill value="{95}">PHP</Skill>
            <Skill value="{95}">Ruby</Skill>
            <Skill value="{90}">Vue.js</Skill>
        </div>
        <div
            class="
            flex flex-col
            lg:flex-row
            items-center
            lg:space-x-12
            space-y-12
            lg:space-y-0
            "
        >
            <Skill value="{85}">Javascript / Typescript</Skill>
            <Skill value="{80}">HTML 5</Skill>
            <Skill value="{80}">CSS 3</Skill>
        </div>
    </div>
</div>

  